import * as angular from "angular";
import {IController, IQService, IWindowService} from "angular";
import * as _ from "lodash";
import {BarcodeScannerService} from "../../modules/commons/services/barcode-scanner-service.service";
import {BringozToastService} from "../../modules/commons/services/bringoz-toast.service";
import {PrinterService} from "../../modules/commons/services/printer-service.service";
import {SplitService} from "../../modules/commons/services/split-service.service";
import {AuthService} from "../../modules/authentication/services/auth-service.service";
import {SiteContextService} from "../../modules/commons/services/site-context.service";
import {OmsOrdersNotificationsService} from "../../modules/commons/services/oms-orders-notifications.service";
import {ViewsStateType} from "../../modules/commons/types/views-state.type";
import {SsoConfigModel} from "../../modules/authentication/models/sso-config.model";

export class RightSideNavCtrl implements IController {

  public resources: any;
  private skins: any;
  private selectedSkin: any;
  private barcodeEnable: any;
  private currentTab: any;
  private resourcesMap: any;
  private selectedTimeZone: any;
  public isPartialSuperSearch: boolean;
  private printingConfig: any;
  private printerList: any;
  private printersLoading: any;
  public isSideNavOpen: boolean;
  public currentYear: string;
  public isShowNewOrderNotifications: boolean;
  public isShowNewOrderNotificationsEnabled: any;
  public viewsStateTypes: typeof ViewsStateType = ViewsStateType;
  // public viewsStateTypes: string[] = ['firstPage', 'secondPage', 'thirdPage'];
  public defaultHomePageSettings: any;
  public ssoConfig: SsoConfigModel;
  public queryString: string;
  public currentUser: any;


  /* @ngInject */
  constructor(private $scope, private $mdSidenav, private triSkins, private bringozToastService: BringozToastService, public UserService, private $state, private $log,
              private $cookies, private $window: IWindowService, private splitService: SplitService, private barcodeScannerService: BarcodeScannerService,
              private authService: AuthService, private printerService: PrinterService, private $q: IQService, private moment, private IamRequests,
              private siteContextService: SiteContextService, private omsOrdersNotificationsService: OmsOrdersNotificationsService) {
    this.skins = this.triSkins.getSkins();
    this.selectedSkin = this.triSkins.getCurrent();
    this.barcodeEnable = this.splitService.getBarcodeConfig().enable;
  }

  $onInit() {
    this.currentTab = 0;
    // Cache current user to avoid multiple calls
    this.currentUser = this.UserService.getCurrentUser();
    this.resourcesMap = undefined;

    //Timezone Configurations
    this.selectedTimeZone = this.$window.localStorage.getItem('TIME_ZONE_KEY');

    //Super Search Configurations
    const partialSearchStorageValue = this.$window.localStorage.getItem('PARTIAL_SUPER_SEARCH');
    this.isPartialSuperSearch = _.isNull(partialSearchStorageValue) || (partialSearchStorageValue === 'true');

    //Printing Configurations
    this.printingConfig = {
      selectedPrinter: undefined,
      enabled: false,
      code: undefined
    };
    this.printerList = [];
    this.printersLoading = false;
    this.currentYear = this.moment().year();

    // Init Navbar Printers
    this._initPrinters();
    // this._getDefaultHomePage();


  }

  $doCheck() {
    const isSite = this.siteContextService.isSite();
    this.isShowNewOrderNotifications = isSite ? this.siteContextService.getSiteInfo().showNewOrderNotifications : undefined;
    this.isShowNewOrderNotificationsEnabled = isSite ? this.splitService.getIsNewOrderNotificationsEnabled() : undefined;


    this.ssoConfig = this.IamRequests.getSsoConfig();
    this.isSideNavOpen = this.$mdSidenav('notifications').isOpen();
    if (!!this.resources && !this.isSideNavOpen) {
      this.currentTab = 0;
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // onChangeDefaultHomePage(key) {
  //   if (this.defaultHomePageSettings) {
  //     const defaultHomePageSettingsCopy = {...this.defaultHomePageSettings, settings: {value: key}}
  //     // defaultHomePageSettingsCopy;
  //     this.viewSettingsService.updateByUser(defaultHomePageSettingsCopy.id, defaultHomePageSettingsCopy)
  //         .then((viewSettingsTable: ViewSettingsModel) => {
  //           this.defaultHomePageSettings = viewSettingsTable;
  //         })
  //   } else {
  //     const viewTableSettings = {
  //       settings: {value: key},
  //       holderType: ViewSettingsHolderType.User,
  //       settingsType: ViewSettingsType.HomePage
  //     }
  //     this.viewSettingsService.createByUser(viewTableSettings)
  //         .then((viewSettingsTable: ViewSettingsModel) => {
  //           this.defaultHomePageSettings = viewSettingsTable
  //         })
  //   }
  // }

  onTabSelect(tab) {
    this.currentTab = tab;
    this.queryString = undefined;

    // Init Navbar Resources
    if (tab === 1) {
      if (!this.resources) {
        this._initResources();
      } else {
        this._setResourcesMap(this.resources);
      }
    }
  }

  setSkin() {
    if (this.selectedSkin !== this.triSkins.getCurrent()) {
      this.$cookies.put('triangular-skin', angular.toJson({
        skin: this.selectedSkin.id
      }));
      this.$window.location.reload();
    }
  }

  toggleBarcode() {
    if (this.barcodeEnable) {
      this.barcodeScannerService.startListening();
    } else {
      this.barcodeScannerService.stopListening();
    }
    this.splitService.setBarcodeConfig(this.barcodeEnable);
  }

  onToggleShowNewOrderNotification() {
    this.splitService.setIsNewOrderNotificationsEnabled(this.isShowNewOrderNotificationsEnabled);
    if (this.isShowNewOrderNotificationsEnabled) {
      this.omsOrdersNotificationsService.initOrdersChannelNotifications();
    } else {
      this.omsOrdersNotificationsService.destroyOmsOrdersNotifications();
    }
  }

  onChangeIsPartialSuperSearch(isPartialSuperSearch: boolean) {
    this.isPartialSuperSearch = isPartialSuperSearch;
    this.$window.localStorage.setItem('PARTIAL_SUPER_SEARCH', isPartialSuperSearch.toString());

  }

  onQueryStringChanged(queryString) {
    this.queryString = queryString;
    this._setResourcesMap(this.resources);
  }

  togglePrinting(isEnabled) {
    this.printerService.setPrintingEnabled(isEnabled);
    if (isEnabled) {
      this._initPrinters()
    } else {
      this.printingConfig = {
        selectedPrinter: undefined,
        enabled: false,
        code: undefined
      };
      this.printerList = [];
    }
  }

  onSelectedPrinterChange(selectedPrinter) {
    this.printingConfig.selectedPrinter = selectedPrinter;
    this.printerService.setSelectedPrinter(selectedPrinter);
  }

  onPrintCodeChange(code) {
    this.printingConfig.code = code;
    this.printerService.setPrinterCode(code);
  }

  switchTimeZone(zoneId) {
    if (this.selectedTimeZone != zoneId) {
      this.selectedTimeZone = zoneId;
      if (zoneId) {
        this.splitService.setSelectedTimeZone(zoneId);
      } else { //Default selected
        this.$window.localStorage.removeItem('TIME_ZONE_KEY');
        this.moment.tz.setDefault();
      }
      const message = {
        body: 'TIME_ZONE_CHANGED'
      };
      this.bringozToastService.info(message);
    }
  }

  close() {
    this.$mdSidenav('notifications').close();
  }

  onLogout() {
    this.UserService.logout()
      .then(() => {
        this.logout();
      });
  }

  logout() {
    this.authService.logout()
      .then(() => {
        this.onAfterLogout();
      })
      .catch((error) => {
        this.$log.debug(error);
      })
  }

  onAfterLogout() {
    var printingConfig = this.printerService.getPrintingConfig();
    const language = this.$window.localStorage.getItem('NG_TRANSLATE_LANG_KEY');
    const siteOmsSettings = this.$window.localStorage.getItem('siteOmsSettings');
    const siteDeliveriesSettings = this.$window.localStorage.getItem('siteDeliveriesSettings');
    const siteFulfillmentSettings = this.$window.localStorage.getItem('siteFulfillmentSettings');
    const localTenant = this.$window.localStorage.getItem('X-BRINGOZ-TENANT-ID'); // for DEV


    this.$window.localStorage.clear();
    this.$window.localStorage.setItem('NG_TRANSLATE_LANG_KEY', language);
    this.$window.localStorage.setItem('siteOmsSettings', siteOmsSettings);
    this.$window.localStorage.setItem('siteDeliveriesSettings', siteDeliveriesSettings);
    this.$window.localStorage.setItem('siteFulfillmentSettings', siteFulfillmentSettings);
    this.$window.localStorage.setItem('X-BRINGOZ-TENANT-ID', localTenant);
    this.printerService.setPrintingConfig(printingConfig);

    // BringozHelp.shutDown();
    // this.intercom.shutDown();

    this.$state.go('authentication.login');
  }

  // ******************************
  //        Private methods
  // ******************************

  // private _getDefaultHomePage(){
  //   this.viewSettingsService.getByUser(undefined, ViewSettingsType.HomePage)
  //     .then((defaultHomePageSettings) => {
  //       this.defaultHomePageSettings = defaultHomePageSettings ? defaultHomePageSettings[0] : undefined;
  //       if (!this.defaultHomePageSettings.settings) {
  //         this.defaultHomePageSettings.settings = {};
  //       }
  //     })
  // }


  private _initPrinters() {
    const printingConfig = this.printerService.getPrintingConfig();

    this.printingConfig = {
      selectedPrinter: undefined,
      enabled: printingConfig.enabled || false,
      code: printingConfig.code
    };

    if (printingConfig.enabled) {
      this.printersLoading = true;

      this.printerService.getLocalDevices()
        .then((printerList: any) => {
          this.printerList = printerList;

          const selectedPrinter = _.find(printerList, (p) => {
            return p.uid === printingConfig.uid
          });
          return selectedPrinter ? this.$q.when(selectedPrinter) : this.printerService.getDefaultDevice();
        })
        .then((printerToSelect) => {
          this.printingConfig.selectedPrinter = printerToSelect;
          this.printerService.setSelectedPrinter(printerToSelect);
        })
        .catch((e) => {
        })
        .finally(() => {
          this.printersLoading = false;
        })
    }
  }

  private _initResources() {
    this.resources = undefined;
    this.IamRequests.getResources()
      .then((resources) => {
        this.resources = resources || [];
        this._setResourcesMap(resources);
      })
  }

  private _setResourcesMap(resources) {
    this.resourcesMap = {};

    _.forEach(resources, (resource) => {
      if (_.isUndefined(resource.parentId)) {
        !this.resourcesMap[resource.id] ?
          this._setResourceObject(resource.id, resource.name, resource) :
          this.resourcesMap[resource.id].list.unshift(resource);
      } else {
        !this.resourcesMap[resource.parentId] ?
          this._setResourceObject(resource.parentId, resource.parent.name, resource) :
          this._setSiteResourceListItem(resource);
      }
    });

    if (!!this.queryString) {
      _.forOwn(this.resourcesMap, (value, key) => {
        if (!value.list.length) {
          _.unset(this.resourcesMap, key);
        }
      })
    }
  }

  private _setResourceObject(id, name, resource) {
    this.resourcesMap[id] = {
      id: id,
      name: name,
      open: !!this.queryString,
      list: (this.queryString && !(resource.name.toLowerCase()).includes(this.queryString.toLowerCase())) ? [] : [resource]
    }
  }

  private _setSiteResourceListItem(resource) {
    if (!!this.queryString && !(resource.name.toLowerCase()).includes(this.queryString.toLowerCase())) {
      return;
    }
    this.resourcesMap[resource.parentId].list.push(resource);
  }


}

angular
  .module('bringoz.admin.commons')
  .component('rightSideNav', {
    bindings: {},
    template: require('./right-side-nav.html').default,
    controller: RightSideNavCtrl
  });
